import React, { useEffect, useState } from "react"

import { Row, Col } from "reactstrap"

// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import { useSelector, useDispatch, connect } from "react-redux"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import ReviewBox from "../../newcomponents/ReviewBox"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"
// import ReviewBox from "./ReviewBox"
import config from "config/config"
import axios from "axios"
import SnackbarComponent from "components/SnackBar"
import MiniCards from "newcomponents/mini-cards"

const Dashboard = props => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )
  const { organizations, isConsolidatedView } = useSelector(
    state => state.organizationReducer,
  )
  const userData = useSelector(state => state.Login.userData)
  const [report, setReport] = useState([])
  const [reviews, setReviews] = useState([])
  const [doctors, setDoctors] = useState([])
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const mode = useSelector(state => state.Layout.layoutMode)

  console.log("active: ", activeOrganization)
  document.title = "Dashboard | AeraVue"

  const breadcrumbItems = [
    {
      title: `${activeOrganization?.name}`,
      link: "#",
    },
    { title: "Dashboard", link: "#" },
  ]

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getReviews?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
      setErr("Error fetching reviews.")
    }
  }
  const fetchDoctors = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getDoctors?integrationId=${
          isConsolidatedView
            ? organizations
                .map(org => org.Organization.HealthgradeIntegrations[0].id)
                .join(",")
            : activeOrganization.HealthgradeIntegrations[0].id
        }`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )

      setDoctors(response.data.doctors)
    } catch (err) {
      console.log(err)
      setErr("Error fetching reviews.")
    }
  }

  useEffect(() => {
    props.setBreadcrumbItems(
      `${activeOrganization?.name} (${activeOrganization?.type})`,
      breadcrumbItems,
    )

    fetchReviews()
    fetchDoctors()
  }, [activeOrganization, isConsolidatedView, organizations])

  useEffect(() => {
    if (doctors && doctors.length > 0 && reviews && reviews?.length) {
      let count = 0
      let sum = 0
      for (const review of reviews) {
        count++
        sum = sum + review.rating
      }

      const average_rating = sum / count

      setReport([
        {
          title: "Doctors",
          iconClass: "doctor",
          total: doctors.length,
          average: "+11%",
          badgecolor: "info",
        },
        {
          title: "Reviews",
          iconClass: "message-draw",
          total: reviews.length,
          average: "-29%",
          badgecolor: "danger",
        },
        {
          title: "Average Rating",
          iconClass: "star",
          total: average_rating.toFixed(1),
          average: "0%",
          badgecolor: "warning",
        },
      ])
    }
  }, [reviews, doctors, isConsolidatedView, organizations])

  return (
    <React.Fragment>
      {/*mimi widgets */}
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      {/* <Miniwidget reports={report} /> */}
      <MiniCards reports={report} mode={mode} />

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings setErr={setErr} />
        </Col>

        <Col xl="6">
          {/* Email sent */}
          <EmailSent setErr={setErr} />
        </Col>

        <Col xl="3">
          {/* <MonthlyEarnings2 /> */}
          <Inbox />
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <MonthlyEarnings2 />
        </Col>
      </Row>
      <Row>
        {/* {reviews.map((review, index) => (
          <Col xl={3} key={index}>
            <ReviewBox review={review} />
          </Col>
        ))} */}
        <ReviewBox mode={mode} reviews={reviews} platform="healthgrade" />
      </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
